import React, { useContext } from "react";
import { Link } from "gatsby";
import "../assets/css/reeddi.css";
import { ContactFormContext } from "../context/contactFormContext";

export default function Footer() {
  const { handleOpenContact } = useContext(ContactFormContext);

  return (
    <footer>
      <div className="w-11/12 mx-auto my-8 md:my-16 flex flex-col md:gap-y-16 max-w-7xl">
        <div className="flex flex-col flex-wrap gap-10 font-matter sm:flex-row justify-between gap-x-16">
          <div className="bg-white flex flex-col max-w-[380px] mb-4 sm:max-w-2xl sm:w-[640px] md:max-w-3xl md:w-[768px] lg:max-w-7xl lg:w-[1020px] xl:max-w-[380px]">
            <div className="mb-4">
              <img src="/reeddi.svg" alt="reeddi" />
            </div>

            <div className="flex flex-col flex flex-col">
              <p className="text-sm text-reeddigrey mb-4 max-w-[380px]">
                Reeddi is a climate-tech company that seeks to bridge the
                accessibility gap through sustainable and limitless innovations.
              </p>

              <div className="text-sm text-reeddigrey flex flex-col">
                <p className="mb-2">
                  <p className="font-semibold">Email us:</p> hello@reeddi.com{" "}
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col mb-4 min-w-fit">
            <p className="font-semibold mb-4">Products</p>
            <div className="text-sm text-reeddigrey flex flex-col">
              <Link to="/reeddi-capsule" className="block mb-4">
                Reeddi capsule
              </Link>
              <Link to="http://tempown.com/" className="block md:mt-0">
                TempOwn
              </Link>
            </div>
          </div>

          <div className="flex flex-col min-w-fit flex flex-col">
            <p>
              <p className="font-semibold mb-4">The Company</p>
            </p>
            <div className="text-sm text-reeddigrey flex flex-col mb-4 ">
              <Link
                to="/#Contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenContact(true);
                }}
                className="block mb-4 md:mt-0"
              >
                Contact Us
              </Link>
              <Link to="/awards" className="block md:mt-0">
                Awards & Impact
              </Link>
            </div>
          </div>

          <div className="flex flex-col mb-4 min-w-fit">
            <p>
              <p className="font-semibold mb-4">Learn</p>
            </p>
            <div className="text-sm text-reeddigrey flex flex-col mb-4 ">
              <Link to="/research" className="block mb-4">
                Research
              </Link>
              <Link to="/ambassador" className="block md:mt-0">
                Ambassadors
              </Link>
            </div>
          </div>

          <div className="flex flex-col mb-4 min-w-fit">
            <p>
              <p className="font-semibold mb-4">Contact</p>
            </p>

            <div className="flex flex-col mb-4">
              <div className="text-sm  mb-4">
                <p className="text-black">
                  <p className="font-semibold">🇨🇦 Toronto, Canada.</p>
                </p>
                <p className="text-reeddigrey">100 College St Suite 150</p>
                <p className="text-reeddigrey">Toronto, ON M5G 1L5 Canada.</p>
                <p className="text-reeddigrey">Tel: +16474554327</p>
              </div>

              <div className="text-sm ">
                <p className="text-black">
                  <p className="font-semibold">🇳🇬 Lagos, Nigeria.</p>
                </p>
                <p className="text-reeddigrey">Shell Workspace,</p>
                <p className="text-reeddigrey">
                  44 Bourdillon Road, Ikoyi, Lagos.
                </p>
                <p className="text-reeddigrey">Tel: +234 812 288 8638</p>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden flex-col-reverse md:flex md:flex-row font-matter justify-between items center gap-x-20 border-y border-cstm-green py-2">
          <p className="my-2 sm:my-0 text-xs sm:text-sm">
            2022 Reeddi Inc. All Rights Reserved
          </p>

          <div className="my-3  sm:my-0 flex sm:justify-between items-center gap-x-4 text-xs">
            <Link to="/terms-of-use">Terms of service</Link>
            <Link to="/policies">Policies</Link>
          </div>

          <div className="my-2 sm:my-0 flex sm:justify-between items-center gap-x-8">
            <Link to="https://twitter.com/Reeddi">
              <img
                className="w-4 md:w-auto"
                src="/icons/twitter.svg"
                alt="twitter"
              />
            </Link>
            <Link to="https://www.facebook.com/Reeddi/">
              <img
                className="w-4 md:w-auto"
                src="/icons/facebook.svg"
                alt="facebook"
              />
            </Link>
            <Link to="https://www.instagram.com/reeddihq/">
              <img
                className="w-4 md:w-auto"
                src="/icons/insta.svg"
                alt="insta"
              />
            </Link>
            <Link to="https://www.youtube.com/channel/UCdBac6w8Yo4c8r9TB74mNvg">
              <img
                className="w-4 md:w-auto"
                src="/icons/youtube.svg"
                alt="youtube"
              />
            </Link>
          </div>
        </div>

        <div>
          {/* mobile footer */}
          <div className="md:hidden mt-10 flex flex-col-reverse md:flex-row font-matter justify-between items center gap-x-20 border-y border-cstm-green py-2">
            <div className="my-2 md:my-0 flex md:justify-between items-center md:gap-x-8">
              <Link to="https://twitter.com/Reeddi">
                <img
                  className="w-4 md:w-auto ml-1 mx-3"
                  src="/icons/twitter.svg"
                  alt="twitter"
                />
              </Link>
              <Link to="https://www.facebook.com/Reeddi/">
                <img
                  className="w-4 md:w-auto mx-3"
                  src="/icons/facebook.svg"
                  alt="facebook"
                />
              </Link>
              <Link to="https://www.instagram.com/reeddihq/">
                <img
                  className="w-4 md:w-auto mx-3"
                  src="/icons/insta.svg"
                  alt="insta"
                />
              </Link>
              <Link to="https://www.youtube.com/channel/UCdBac6w8Yo4c8r9TB74mNvg">
                <img
                  className="w-4 md:w-auto mx-3"
                  src="/icons/youtube.svg"
                  alt="youtube"
                />
              </Link>
            </div>
          </div>
          <div className="flex flex-col-reverse md:hidden md:flex-row font-matter justify-between items center gap-x-20 py-2">
            <p className="my-2 md:my-0 text-xs md:text-sm">
              2022 Reedd Inc. All Rights Reserved
            </p>

            <div className="my-3  md:my-0 flex md:justify-between items-center gap-x-4 text-xs">
              <Link to="/terms-of-use">Terms of service</Link>
              <Link to="/policies">Policies</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
